import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { CstmPagination } from "../../../components/Common/Common";

// img
import u1 from "../../../Assets/images/user.png";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../components/Common/Table";
import CustomPagination from "../../../components/Common/CustomPagination";
import {
  editService,
  getVendor,
  removeVendor,
  updateVendorList,
} from "../../../store/actions";
import moment from "moment";
import DeleteModel from "../../../components/Common/DeleteModel";
import Search from "../../../components/Common/Search";
import StatusFilter from "../../../components/Common/StatusFilter";
import { serviceTypeFilterOptionArr, statusFilterOptionArr } from "../../../utilities/const";
import PaginationFilter from "../../../components/Common/PaginationFilter";
import { BLOCK_UNBLOCK_VENDOR } from "../../../services/ApiCalls";
import { toast } from "react-toastify";
import TableProfile from "../../../components/Common/TableProfile";
import config from "../../../config";

const Vendors = () => {
  const [Delete, setDelete] = useState({
    open: false,
    dumpId: "",
  });

  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    search: "",
    status: "all",
    role: "vendors"
  });
  // console.log(body, "body")
  const dispatch = useDispatch();

  const vendorData = useSelector((s) => s.vendor.vendorListData);
  const vendorDataTotal = useSelector((s) => s.vendor.total);
  const loader = useSelector((s) => s.vendor.loading);

  const pageChangeHandler = (page) => {
    const newbody = {
      ...body,
      page,
    };
    setBody((p) => ({
      ...p,
      page,
    }));
    dispatch(getVendor(newbody));
  };



  useEffect(() => {
    const newbody = {
      ...body,
      page: 1,
    };
    setBody(newbody);
    if (body?.search.trim() === "") dispatch(getVendor(newbody));
  }, [body.search]);

  const statusChangeHandler = async (item, ind) => {
    const OldVendorsData = [...JSON.parse(JSON.stringify(vendorData))];
    const newVendors = [...vendorData];
    const obj = newVendors[ind];

    obj.status = obj?.Status === "active" ? "inactive" : "active";

    dispatch(updateVendorList(newVendors));

    try {
      const res = await BLOCK_UNBLOCK_VENDOR({
        providerId: item._id,
        status: newVendors[ind].status,
      });

      if (res.data.status === "success") {
        toast.success(res?.data?.message);
        fetchVendorList();
      } else {
        toast.error("Failed to update status");
        dispatch(updateVendorList(OldVendorsData));
      }
    } catch (error) {
      dispatch(updateVendorList(OldVendorsData));
      toast.error("Something went wrong");
    }
  };

  const searchHandler = (e) => {
    const newbody = {
      ...body,
      page: 1,
    };
    setBody((p) => ({
      ...p,
      page: 1,
    }));
    dispatch(getVendor(newbody));
  };

  const fetchVendorList = () => {
    const newbody = {
      ...body,
      page: 1,
    };

    setBody(newbody);

    dispatch(getVendor(newbody));
  }

  useEffect(() => {
    fetchVendorList()
  }, [body.status, body.limit, body.type]);

  const handleCopyVendorWidget = (item) => {
    let widgetHtml = `<iframe src="${config.baseURL}/widget/get-it-by-delivit/${item?._id}?price={productPrice}&return_url={callbackUrl}" style="border:none;height:45px"></iframe>`
    navigator.clipboard.writeText(widgetHtml)
      .then(() => {
        toast.success('Widget copied to clipboard!');
      })
      .catch(err => {
        toast.error('Failed to copy text:', err);
      });
  }

  const col = [
    {
      label: "Sr no",
      id: "srNo",
      isComponent: true,
      component: (_, key) => (
        <p className={` m-0`}>{(body.page - 1) * body.limit + (key + 1)}</p>
      ),
    },
    {
      label: "Business Name",
      isComponent: true,
      id: "name",
      component: (item, key) => {
        return <p>{item?.name}</p>;
      },
    },
    {
      label: "Business Email",
      isComponent: true,
      id: "email",
      component: (item, key) => {
        return <p>{item?.email}</p>;
      },
    },
    {
      label: "Mobile Number",
      isComponent: true,
      id: "mobileNumber",
      component: (item, key) => {
        return <p>{item?.mobileNumber}</p>;
      },
    },
    {
      label: "Postal / ZIP Code",
      isComponent: true,
      id: "pincode",
      component: (item, key) => {
        return <p>{item?.pincode}</p>;
      },
    },
    {
      label: "Status",
      id: "",
      isComponent: true,
      component: (item, ind) => (
        <Form.Check
          type="switch"
          id="custom-switch"
          checked={["active", "approved"].includes(item.Status) ? true : false}
          onClick={() => statusChangeHandler(item, ind)}
        />
      ),
    },

    {
      label: "Created At",
      id: "createdAt",
      classNames: "fw-sbold",
      isComponent: true,
      component: (item) => (
        <p className={` m-0`}>
          {moment(item?.createdAt).format("MM-DD-YYYY , HH:mm A")}
        </p>
      ),
    },
    {
      label: "Actions",
      id: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">

          <Link
            className="border-0 p-0"
            variant="transparent"
            to={`/vendors/view/${item._id}`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 25 17"
              fill="none"
            >
              <path
                d="M24.8389 7.9541C22.8564 5.34668 20.8301 3.35937 18.8184 2.04102C16.7578 0.693359 14.6582 0.00488281 12.5684 0C12.5586 0 12.5488 0 12.5391 0C10.4443 0 8.3252 0.683594 6.25 2.03613C4.22363 3.34961 2.17285 5.3418 0.161133 7.94922C-0.0537109 8.23242 -0.0537109 8.62305 0.161133 8.90137C2.17285 11.5137 4.22363 13.5059 6.25 14.8193C8.33008 16.1719 10.4443 16.8555 12.5391 16.8555H12.5684C14.6582 16.8506 16.7627 16.1621 18.8184 14.8145C20.8301 13.4961 22.8516 11.5088 24.8389 8.90137C25.0537 8.62305 25.0537 8.23242 24.8389 7.9541ZM12.5635 15.293C12.5537 15.293 12.5439 15.293 12.5391 15.293C9.02832 15.293 5.40527 12.9834 1.77246 8.42773C5.40527 3.87207 9.02344 1.5625 12.5391 1.5625H12.5635C16.0645 1.57227 19.6533 3.88184 23.2275 8.42773C19.6533 12.9736 16.0693 15.2832 12.5635 15.293ZM12.5 3.54492C9.80957 3.54492 7.61719 5.73731 7.61719 8.42773C7.61719 11.1182 9.80957 13.3105 12.5 13.3105C15.1904 13.3105 17.3828 11.1182 17.3828 8.42773C17.3828 5.73731 15.1904 3.54492 12.5 3.54492ZM12.5 11.748C10.6689 11.748 9.17969 10.2588 9.17969 8.42773C9.17969 6.59668 10.6689 5.10742 12.5 5.10742C14.3311 5.10742 15.8203 6.59668 15.8203 8.42773C15.8203 10.2588 14.3311 11.748 12.5 11.748Z"
                fill="#666666"
              ></path>
            </svg>
          </Link>

          <Link
            className="border-0 p-0"
            variant="transparent"
            to={`#`}
            onClick={(e) => {
              e.preventDefault()
              handleCopyVendorWidget(item);
            }}
          >
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
              width="20" height="20" viewBox="0 0 512.000000 512.000000"
              preserveAspectRatio="xMidYMid meet">

              <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                fill="#666666" stroke="none">
                <path d="M1175 4583 c-291 -62 -539 -270 -648 -544 -66 -165 -62 -73 -62
-1479 l0 -1275 23 -85 c24 -93 83 -224 132 -296 93 -133 258 -265 406 -322
168 -65 102 -62 1534 -62 1149 0 1310 2 1378 16 212 44 410 168 538 337 62 82
129 221 156 327 l23 85 0 1275 0 1275 -23 85 c-24 93 -83 224 -132 296 -93
133 -258 265 -406 322 -169 65 -101 62 -1541 61 -1121 -1 -1318 -3 -1378 -16z
m2790 -107 c299 -90 516 -323 577 -616 19 -96 19 -2504 0 -2600 -61 -295 -285
-532 -583 -617 -61 -17 -136 -18 -1399 -18 -1263 0 -1338 1 -1399 18 -298 85
-522 322 -583 617 -19 96 -19 2504 0 2600 66 318 329 576 643 629 31 5 620 8
1369 7 1236 -2 1319 -3 1375 -20z"/>
                <path d="M3220 3969 c-288 -74 -480 -321 -480 -614 0 -111 18 -185 72 -294 76
-156 239 -286 409 -326 82 -19 228 -19 304 0 271 69 465 303 482 580 25 426
-377 761 -787 654z m240 -90 c223 -35 409 -227 442 -455 23 -162 -33 -327
-151 -444 -170 -169 -402 -207 -619 -103 -76 37 -198 159 -235 235 -57 119
-71 242 -42 367 46 194 210 353 408 396 77 17 115 18 197 4z"/>
                <path d="M1317 3916 c-90 -33 -153 -95 -188 -186 -17 -46 -19 -79 -19 -374 0
-277 2 -331 17 -376 22 -69 96 -150 165 -181 53 -24 53 -24 448 -24 427 0 435
1 516 56 45 31 89 90 110 146 10 29 13 117 14 374 0 396 -1 401 -90 491 -88
88 -91 88 -549 88 -298 -1 -395 -4 -424 -14z m874 -121 c23 -16 53 -50 66 -74
23 -44 23 -48 23 -365 0 -314 -1 -323 -22 -366 -13 -24 -40 -58 -61 -74 l-39
-31 -399 -3 c-383 -3 -400 -2 -438 18 -44 22 -82 68 -100 119 -14 44 -15 611
0 664 13 49 63 105 114 129 37 17 69 18 427 16 l386 -3 43 -30z"/>
                <path d="M1580 2341 c-222 -31 -404 -196 -455 -412 -17 -75 -20 -236 -4 -311
40 -196 207 -367 400 -413 88 -20 373 -21 453 0 90 24 165 65 232 128 127 118
174 234 174 428 0 78 -6 143 -16 183 -46 180 -188 324 -374 381 -63 19 -319
29 -410 16z m443 -138 c121 -58 204 -156 242 -287 24 -83 17 -268 -13 -346
-43 -110 -139 -206 -251 -251 -48 -19 -80 -23 -215 -27 -181 -5 -252 5 -337
49 -113 56 -205 181 -229 308 -23 121 -8 252 38 351 28 61 118 157 172 185 98
51 124 55 330 53 l195 -3 68 -32z"/>
                <path d="M3073 2275 c-155 -42 -270 -150 -314 -296 -19 -62 -20 -88 -17 -296
l3 -228 34 -70 c42 -85 125 -170 203 -207 92 -44 150 -50 428 -46 237 3 259 5
312 27 116 46 214 143 259 259 21 51 23 78 27 259 2 128 0 221 -8 257 -35 171
-179 314 -350 346 -83 16 -514 12 -577 -5z m553 -96 c115 -21 201 -89 253
-198 26 -55 26 -60 26 -271 0 -211 0 -216 -26 -271 -37 -79 -90 -133 -167
-171 l-67 -33 -265 0 c-232 0 -272 2 -318 18 -71 25 -162 109 -193 179 -23 51
-24 63 -24 278 0 209 1 228 22 272 45 99 150 181 252 198 71 12 440 11 507 -1z"/>
              </g>
            </svg>
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>

      <section className="Service position-relative py-3">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter gap-10 mb-3 d-flex align-itmes-center justify-content-between flex-wrap">
                <div className="left">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-itmes-center gap-10">
                    <StatusFilter
                      body={body}
                      setBody={setBody}
                      statusFilterOptionArr={statusFilterOptionArr}
                    />

                    <PaginationFilter body={body} setBody={setBody} />
                    <Search setBody={setBody} searchHandler={searchHandler} />
                  </ul>
                </div>

              </div>


              <div className="table-responsive">
                <Table data={vendorData} column={col} loader={loader} />
                <div className="d-flex justify-content-end">
                  <CustomPagination
                    total={vendorDataTotal}
                    pageSize={body.limit}
                    current={body.page}
                    pageChangeHandler={pageChangeHandler}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Vendors;
